<app-auth-header [title]="'Select Institution'" [showMenu]="true"></app-auth-header>
<div class="select-inst-content">
  <div class="title">
    Which institution would you like to view?
  </div>
  <p class="search-by-hint">Search by institution name, location or customer number</p>
  <div class="interactive-content-container">
    <div class="search-wrap">
      <i class="eleot-icon icon-search"></i>
      <input
        auto="search-field"
        autofocus
        type="text"
        placeholder="Search"
        [(ngModel)]="searchInputValue"
        (keyup)="searchTerms$.next($event.target.value)"/>
      <i class="eleot-icon icon-close" (click)="searchInputValue = ''" *ngIf="searchInputValue"></i>
    </div>
    <ng-template [ngIf]="searchResults && searchInputValue" [ngIfElse]="notSearching">
      <div class="search-results">
        <ng-template [ngIf]="searchResults.length > 0" [ngIfElse]="noResults">
          <ul class="styleless">
            <li class="pointer" *ngFor="let customer of searchResults" (click)="selectInstitutionFromSearch(customer)">
              <div [ngClass]="{ 'inactive-institution' : !customer.customerActiveFlag }">
                <span [innerHtml]="customer.name | strong: searchInputValue"></span>
                <div class="location" *ngIf="hasAddressInfo(customer)">
                  <span [innerHtml]="customer.city | strong: searchInputValue"></span>,
                  <span [innerHtml]="customer.state | strong: searchInputValue"></span>&nbsp;
                  <span [innerHtml]="customer.postalCode | strong: searchInputValue"></span>
                </div>
                <div class="location">
                  <span [innerHtml]="customer.customerNumber | strong: searchInputValue"></span>
                </div>
              </div>
            </li>
          </ul>
          <div class="number-results" *ngIf="searchResults.length>=15">Top {{searchResults.length}} Results</div>
          <div class="number-results" *ngIf="searchResults.length<15">{{searchResults.length}} Result(s)</div>

        </ng-template>
        <ng-template #noResults>
          <div class="no-results">No Results Found</div>
        </ng-template>
      </div>
    </ng-template>
    <ng-template #notSearching>
      <div  class="tree-view" *ngIf="customers.length > 0">
        <p-tree
          styleClass="select-institution-tree"
          [value]="customers"
          (onNodeExpand)="loadChildren($event)"
          (onNodeCollapse)="collapseChildren($event)"
          selectionMode="single"
          (onNodeSelect)="selectInstitutionFromTree($event.node.data)"
          [loading]="childrenLoading"
          loadingIcon="fa fa-spinner">
        </p-tree>
      </div>
    </ng-template>
  </div>
</div>

